import React from 'react';
import { connect } from '@atlassian/jira-react-redux';
import { AllAtlasGoals } from './all-atlas-goals';
import mapDispatchToProps from './command';
import type { Props } from './types';

const GoalCell = (props: Props) => <AllAtlasGoals {...props} />;
export default connect(null, mapDispatchToProps)(GoalCell);
